// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2mSyr","disabled":"FileBtn_disabled__31Hil","warn":"FileBtn_warn__3GXnz","fade":"FileBtn_fade__1EYMP"};